import { SingleSelectField } from "components/RenderInput"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"

export const renderReminderNotifications = ({ fields }) => {
  const notificationOptions = [
    {
      value: 1,
      label: "In-app notification",
    },
    {
      value: 2,
      label: "Email notification",
    },
  ]

  const durationOptions = [
    { value: 5, label: "5 min" },
    { value: 10, label: "10 min" },
    { value: 15, label: "15 min" },
    { value: 30, label: "30 min" },
    { value: 60, label: "1 hour" },
    { value: 120, label: "2 hours" },
    { value: 240, label: "4 hours" },
    { value: 360, label: "6 hours" },
    { value: 720, label: "12 hours" },
    { value: 1440, label: "1 day" },
    { value: 2880, label: "2 days" },
    { value: 10080, label: "1 week" },
  ]

  return (
    <React.Fragment>
      {fields.map((notificaiton, index) => {
        return (
          <React.Fragment key={index}>
            <Row className={index === 0 ? "mb-3" : "my-3"}>
              <Col xs="auto">
                <div style={{ minWidth: "200px" }}>
                  <Field
                    name={`${notificaiton}.type`}
                    component={SingleSelectField}
                    options={notificationOptions}
                    isSearchable={false}
                  />
                </div>
              </Col>
              <Col xs="auto">
                <div style={{ minWidth: "120px" }}>
                  <Field
                    name={`${notificaiton}.time_period`}
                    component={SingleSelectField}
                    options={durationOptions}
                    isSearchable={false}
                  />
                </div>
              </Col>
              <Col xs="auto" className="mt-2">
                before start
              </Col>
              <Col xs="auto" className="mt-2">
                <i
                  className="bx bx-sm bx-x"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    fields.remove(index)
                  }}
                />
              </Col>
            </Row>
          </React.Fragment>
        )
      })}
      <Row className="mt-1">
        <Col>
          <span
            style={{ cursor: "pointer", color: "#556ee6" }}
            onClick={() => fields.push({ type: 1, time_period: 30 })}
          >
            Add Another
          </span>
        </Col>
      </Row>
    </React.Fragment>
  )
}
